<template>
<v-content class="spinelab-website-front">
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <h1 class="text-sm-left">会社案内出力</h1>
      </v-flex>

      <v-flex xs12 sm12 md12>
        <p class="select_pdf_msg">
            「ホームページ作成サービス」で入力していただいた文章や写真がA4サイズの会社案内に！<br />
            以下の手順で簡単に自動で作成できます！<br />
            何度でも修正可能なので、PDFをダウンロードしてレイアウト確認の上、<br />
            「ホームページ作成サービス」で写真や文章を追加するなど調節してみてください。
        </p>
      </v-flex>
      <v-flex xs12 sm12 md12>
        <p>手 順</p>
        <p>
          1. デザインを選ぶ <br/>
          2. 「PDFをダウンロード」をクリック <br />
          3. 自動生成されたPDFファイルを印刷 <br />
        </p>
        <p>※両面印刷する場合はプリンターで設定してください</p>
      </v-flex>

      <v-flex xs12 sm12 md12>
        <h2>会社案内印刷の背景デザイン選択</h2>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs3 sm3 md3 v-for="designNumber in designNumbers" :key="designNumber">
        <div
          @click="selectDesign(designNumber)"
        >
          <img
            :src="`static/img/thm_bso_company_bg-img${designNumber}.png`"
            :class="{'design-selected': designNumber === selectedDesignNumber}"
            >
        </div>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-btn @click="download()"
             color="success"
             :loading="loading">
        PDFをダウンロード
      </v-btn>
    </v-layout>
  </v-container>
</v-content>
</template>

<script>
import { mapState } from 'vuex';
import { saveAs } from 'file-saver';

export default {
  name: 'ExportPdf',
  data() {
    return {
      loading: false,
      selectedDesignNumber: 1,
      designNumbers: [1, 2, 3, 4, 5, 6, 7, 8],
    };
  },
  computed: {
    ...mapState({
      requests: state => state.requests,
      siteId: state => state.siteId,
    }),
  },
  methods: {
    selectDesign(number) {
      this.selectedDesignNumber = number;
    },
    async download() {
      this.loading = true;
      const pdf = await this.requests.getCompanyPdf(this.siteId, this.selectedDesignNumber);
      const blob = new Blob([pdf], { type: 'application/pdf' });
      saveAs(blob, 'download.pdf');
      this.loading = false;
    },
  },
};
</script>

<style scoped>
img {
  border: solid 6px transparent;
  cursor: pointer;
}

img.design-selected {
  border: solid 6px green;
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/ExportPdf.vue